import { Component, Inject } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { LicenseService } from "../../../services/LicenseService";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { ElementInstructionMap } from "@angular/animations/browser/src/dsl/element_instruction_map";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    selector:'add-lz30-device',
    template:require('./add-lz30-device.component.html'),
    styles:[require('./add-lz30-device.component.css')]
})
export class AddEditLZ30DeviceComponent{
    userDeviceDisplayDetail;
    dialogTitle;
    SelectedCustomerDetail;
    lz30AddDeviceForm;
    errorMessage='';
    constructor(
        private dialogRef:MdDialogRef<AddEditLZ30DeviceComponent>,
        private formBuilder:FormBuilder,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData:any
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.userDeviceDisplayDetail=dialogData.userDeviceDisplayData
        this.SelectedCustomerDetail=dialogData.SelectedCustomerDetail
        if(this.SelectedCustomerDetail){
            this.dialogTitle="Edit Device Info"
            this.lz30AddDeviceForm.patchValue({
                MACAddress:this.SelectedCustomerDetail.MACAddress,
                DeviceSerialNo:this.SelectedCustomerDetail.DeviceSerialNo
            })
        }
        else{
            this.dialogTitle="Add Device"
        }
    }
    buildForm(){
        this.lz30AddDeviceForm=this.formBuilder.group({
            MACAddress:['',[Validators.required,Validators.pattern]],
            DeviceSerialNo:['',Validators.required]
        })
    }
    onSave(){
        this.appLoader.open()
        if(this.SelectedCustomerDetail){
            let model={
                MACAddress:this.lz30AddDeviceForm.value.MACAddress,
                DeviceSerialNo:this.lz30AddDeviceForm.value.DeviceSerialNo,
                UpdatedBy:Number(localStorage.getItem('userid')),
                LZ30DeviceId:this.SelectedCustomerDetail.LZ30DeviceId
            }
            this.licenseService.updateLz30Device(model).subscribe((data)=>{
                if(!data.IsError && data.DataObject!=null){
                    this.userDeviceDisplayDetail=data.DataObject;
                    this.dialogRef.close(this.userDeviceDisplayDetail);
                }
                else{
                    this.errorMessage=data.Error;
                }
                this.appLoader.close()      
            })
        }
        else{
            let model={
                MACAddress:this.lz30AddDeviceForm.value.MACAddress,
                DeviceSerialNo:this.lz30AddDeviceForm.value.DeviceSerialNo,
                CreatedBy:Number(localStorage.getItem('userid'))
            }
            this.licenseService.addLz30Device(model).subscribe((data)=>{
                if(!data.IsError && data.DataObject!=null){
                    this.userDeviceDisplayDetail=data.DataObject
                    this.dialogRef.close(this.userDeviceDisplayDetail);
                }
                else{
                    this.errorMessage=data.Error;
                }
                this.appLoader.close()
            })
        }
    }
    onCancel(){
        this.dialogRef.close(this.userDeviceDisplayDetail);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/lz30/add-lz30-device/add-lz30-device.component.ts